"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowPreviousStateRefined = exports.buildWorkflowRefined = void 0;
const buildWorkflowRefined = (workflowDefProperties) => ({
    ID: workflowDefProperties.ID,
    initialState: workflowDefProperties.initialState,
    states: workflowDefProperties.states,
    transitions: workflowDefProperties.transitions,
});
exports.buildWorkflowRefined = buildWorkflowRefined;
const buildWorkflowPreviousStateRefined = (prevState) => ({
    state: prevState.previousWorkflowEntity.currentState,
    stateLabel: prevState.previousWorkflowEntity.currentStateLabel,
    workflowID: prevState.previousWorkflowEntity.workflowID,
    objectID: prevState.PK.split(`WORKFLOW|${prevState.previousWorkflowEntity.workflowID}|`)[1],
    timeStarted: prevState.previousWorkflowEntity.updated,
    timeEnded: Number(prevState.SK.split('TIME|')[1]),
    timeSpent: Number(prevState.SK.split('TIME|')[1]) - prevState.previousWorkflowEntity.updated,
});
exports.buildWorkflowPreviousStateRefined = buildWorkflowPreviousStateRefined;
//# sourceMappingURL=WorkflowRefined.js.map